import React, {useEffect} from 'react';
import moment from 'moment';
import 'moment/locale/pt';
import {Column, Row} from '../../../components/layout';
import colors from '../../../util/colors';
import {PreAuthorizationItem} from '../PreAuthorizations';

import ReimbursementListItemStatus from '../../reimbursements/reimbursement-history/components/ReimbursementListItemStatus';
import {compose} from 'redux';
import {connect} from 'react-redux';
import 'moment/locale/sr';

type PreAuthorizationListItemProps = {
  preAuthorizationItem: PreAuthorizationItem;
  statuses: {
    value: string;
    label: string;
    statedId: string;
    colorCode: string;
  }[];
  selectedItem(filterItem: PreAuthorizationItem): void;
  buStyles: any;
  language: string;
  userLanguage: string;
};

function PreAuthorizationtListItem(props: PreAuthorizationListItemProps) {
  let statusId = props.preAuthorizationItem.decisionState;
  let currentStatus = props.statuses.find((e) => e.value == statusId);
  let color = currentStatus?.colorCode;
  let stateDescription = currentStatus?.label;
  useEffect(() => {
    const dateLanguage =
      (props.language || props.userLanguage)?.split('-')[0] === 'rs'
        ? 'sr'
        : (props.language || props.userLanguage)?.split('-')[0];
    moment.locale(dateLanguage);
  }, []);
  return (
    <>
      <Row>
        <Column className="reimbursement-history-declarationlist-column1">
          <strong>
            {moment(props.preAuthorizationItem.dos)
              .format('DD MMM')
              .toUpperCase()}
          </strong>
          {new Date(props.preAuthorizationItem.dos).getFullYear()}
        </Column>
        <Column className="reimbursement-history-declarationlist-column2">
          {props.preAuthorizationItem.svcGrp ? (
            <strong
              style={{color: props.buStyles?.primaryColor || colors.blue}}>
              {props.preAuthorizationItem.svcGrp}
            </strong>
          ) : (
            <strong
              style={{color: props.buStyles?.primaryColor || colors.blue}}>
              {'-'}
            </strong>
          )}

          {props.preAuthorizationItem.clinicName}
        </Column>
        <Column className="reimbursement-history-declarationlist-column3">
          <ReimbursementListItemStatus
            color={color}
            stateDescription={stateDescription}
          />
        </Column>{' '}
      </Row>
      <div className="reimbursement-history-declarationlist-line"></div>
    </>
  );
}

const mapStateToProps = ({globalStyles, language, user}: any) => ({
  buStyles: globalStyles.value,
  language: language.value,
  userLanguage: user.value.language,
});

export default compose(connect(mapStateToProps)(PreAuthorizationtListItem));
